import React, { useState } from 'react'
import { message, Upload } from "antd";
// @ts-ignore
import get from "lodash/get"
import axios from "axios";
// @ts-ignore
import useTranslation from "hooks/useTranslation";


const ImportModal = ({ showImportModal }: any) => {
  const { tr } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [responseData, setResponseData] = useState();

  const handleUpload = async () => {
    if (!file) {
      message.warning(tr("Fayl tanlanmagan!"));
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    setLoading(true);
    try {
      const response = await axios.post(`${import.meta.env.VITE_API_ROOT}/import-from-pos`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      message.success(tr("Fayl muvaffaqiyatli yuklandi!"));
      setResponseData(response.data);
      showImportModal(false)
    } catch (error) {
      console.error(error);
      message.error(tr("Faylni yuklashda xatolik yuz berdi!"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="modal-title">{tr("Импорт")}</div>
      <div className="modal-body">
        <div>
          <div>
            <div className="!w-full p-6 border rounded-xl shadow-md bg-white cursor-pointer flex justify-center flex-col items-center">
              <Upload
                accept=".json"
                beforeUpload={(file: any) => {
                  setFile(file);
                  return false;
                }}
                showUploadList={false}
              >
                <div className="flex justify-center">
                  <span>{tr("Загрузить файл (json)")}</span>
                </div>
              </Upload>

              {file && (
                <div className="flex items-center mt-[10px] text-blue-600">
                  {/* <FileExcelOutlined style={{ fontSize: 20 }} /> */}
                  <span className="font-medium truncate w-[160px] text-center">{get(file, "name")}</span>
                </div>
              )}
            </div>
            <button
              type="button"
              onClick={handleUpload}
              className={`d-btn d-btn--small d-btn-primary !w-full justify-center mt-[20px] ${loading ? "--loading" : ""}`}
              disabled={loading}
            >
              {tr("Отправить")}
            </button>
          </div>
        </div>
      </div>
    </div >
  )
}

export default ImportModal